// Module 10 — pick resolution. The adapter tags every primitive with `id = {kind,id}`; a click drills
// scene.pick → this resolves the node/edge id to publish to STATE (R9). It never touches the engine —
// re-solves come back as the next snapshot. Pure: just shape-checks the picked object.
import type { PickSel } from "./contract";

export function resolvePick(picked: { id?: unknown } | undefined): PickSel | null {
  const id = picked?.id;
  if (id !== null && typeof id === "object" && "kind" in id && "id" in id) {
    const k = (id as { kind: unknown }).kind;
    const v = (id as { id: unknown }).id;
    if ((k === "node" || k === "edge") && typeof v === "string") return { kind: k, id: v };
    // info/finance packets — the overlay arc LINE ("arc") and its moving arrow GLYPH ("glyph") carry the
    // synthetic from→to packet id. Route them to an "edge" selection so the inspector opens the PACKET
    // datasheet (the "→" id triggers packageSections) and the halo rings the packet. No PickSel widening.
    if ((k === "arc" || k === "glyph") && typeof v === "string") return { kind: "edge", id: v };
    // V4 §3.5(b): a connection-point ("cp") tap. When the primitive carries the DERIVED port id "<edgeId>|u/v"
    // (a half-edge breaker handle), route it to an EDGE selection so the datasheet opens that line with its
    // per-end breaker controls (togglePort). A bare connection_point id (no "|") has no edge/port binding yet,
    // so it stays unresolved. No PickSel widening — consistent with arc/glyph.
    if (k === "cp" && typeof v === "string" && v.includes("|")) return { kind: "edge", id: v.split("|")[0]! };
  }
  return null;
}
